import { render, staticRenderFns } from "./AutomationDialogComponent.vue?vue&type=template&id=488f6496&"
import script from "./AutomationDialogComponent.vue?vue&type=script&lang=js&"
export * from "./AutomationDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports